import LegalShell, { LegalSection } from './LegalShell';

export default function SecurityPage() {
  return (
    <LegalShell testId="security-page" eyebrow="Legal" title="Security & Data Retention">
      <LegalSection n="1" title="How we protect your information">
        <ul>
          <li>All data is encrypted in transit using TLS 1.2+ between your browser, our servers and our infrastructure providers.</li>
          <li>Signed documents are stored in Google Firebase Storage in the <strong>europe-west2 (London)</strong> region, in a private bucket with deny-by-default access rules and admin-SDK-only reads. Downloads are always streamed through our server — no public storage URLs are ever exposed.</li>
          <li>Access to the administrative dashboard is protected by HTTP Basic authentication. No administrative function is available from a public signing link.</li>
          <li>Signing links use single-use, cryptographically random tokens which are linked to the email address the invitation was sent to and expire automatically after 30 days.</li>
          <li>Every signed submission is stamped server-side with the date, time, IP address and browser details of the signer, creating a verifiable audit record.</li>
        </ul>
      </LegalSection>

      <LegalSection n="2" title="Retention policy">
        <p>On submission of a completed agreement, PNC UNIQUE LTD applies the following workflow:</p>
        <ul>
          <li>Your submission is validated server-side.</li>
          <li>A final signed PDF is generated, embedding your details, signature, and the date, time and IP address of signing.</li>
          <li>The signed PDF is stored securely in Firebase Storage and a copy is delivered to <strong>PNC HR (admin@pncunique.com)</strong> using our transactional email provider.</li>
          <li>Signed agreements are contractual records. They are retained for the duration of your engagement with PNC and for up to <strong>6 years</strong> afterwards, in line with the limitation period for contractual claims in England and Wales.</li>
          <li>Authorised administrators may delete individual records — including the stored signed PDF — from the administration dashboard where retention is no longer required.</li>
        </ul>
      </LegalSection>

      <LegalSection n="3" title="What we retain">
        <p>For every completed signing request, PNC UNIQUE LTD retains:</p>
        <ul>
          <li>Contractor full name, business name and invited email address.</li>
          <li>The service type (contract, invoice creation, insurance cover, or health &amp; safety) and the response given.</li>
          <li>Sent, opened and signed/declined status timestamps.</li>
          <li>The IP address and browser user-agent recorded at the moment of signing (for audit and fraud prevention).</li>
          <li>The signed PDF document itself, for the retention period described in section 2.</li>
        </ul>
      </LegalSection>

      <LegalSection n="4" title="Access controls">
        <ul>
          <li>The signing portal is invitation-only. Signing links are single-use and cryptographically linked to the email address the invitation was sent to.</li>
          <li>Signing links cannot be re-used once completed, and expire after 30 days.</li>
          <li>The administrative dashboard is protected by administrator credentials that are rotated per PNC internal policy.</li>
          <li>Firebase Admin SDK service-account credentials are held only server-side and are never exposed to browsers.</li>
          <li>Our email API keys are stored server-side only. No email provider API key is embedded in any frontend bundle.</li>
        </ul>
      </LegalSection>

      <LegalSection n="5" title="Responsible disclosure">
        <p>
          If you believe you have discovered a security vulnerability affecting the PNC UNIQUE LTD
          contract e-signature portal, please report it in confidence to{' '}
          <a href="mailto:admin@pncunique.com">admin@pncunique.com</a>. We acknowledge reports within 5 working days.
        </p>
      </LegalSection>

      <LegalSection n="6" title="Anti-phishing">
        <p>Before entering personal information, always confirm that the address in your browser matches the link in the invitation email you received from PNC. PNC UNIQUE LTD will:</p>
        <ul>
          <li>Never request your signing link or personal details by telephone.</li>
          <li>Never ask you to complete an agreement through any unrelated domain.</li>
          <li>Never ask you to install browser extensions or unusual software.</li>
          <li>Always send invitations from <strong>admin@pncunique.com</strong> — the sender authenticated at our email provider.</li>
        </ul>
        <p>
          If in doubt, do not enter your details. Contact us directly on <strong>0333 090 5024</strong> or by
          email at <a href="mailto:admin@pncunique.com">admin@pncunique.com</a> to verify the invitation.
        </p>
      </LegalSection>

      <LegalSection n="7" title="Company identity">
        <p>PNC UNIQUE LTD, registered in England and Wales.</p>
        <p>Registered office: Headlands House, 1 Kings Court, Kettering Parkway, Kettering, Northamptonshire, NN15 6WJ.</p>
        <p>ICO Registration: <strong>ZB865873</strong>.</p>
        <p>Website: <a href="https://www.pncunique.com" target="_blank" rel="noreferrer">https://www.pncunique.com</a></p>
        <p>Contact: <a href="mailto:admin@pncunique.com">admin@pncunique.com</a> &middot; 0333 090 5024</p>
      </LegalSection>
    </LegalShell>
  );
}
